import type { SettingsWorkspaceSection } from '../services/settings-workspace-schema';
import { useLocale } from '../i18n/LocaleProvider';

export function SettingsSectionNav({
  sections,
  activeSectionId,
  onSelect,
}: {
  sections: SettingsWorkspaceSection[];
  activeSectionId: SettingsWorkspaceSection['id'];
  onSelect: (sectionId: SettingsWorkspaceSection['id']) => void;
}) {
  const { t } = useLocale();

  return (
    <nav aria-label={t('settings.workspace.nav')} className="settings-nav">
      <ul className="settings-nav-list">
        {sections.map((section) => (
          <li key={section.id}>
            <button
              aria-pressed={section.id === activeSectionId}
              className="settings-nav-button"
              onClick={() => onSelect(section.id)}
              type="button"
            >
              <strong>{t(section.titleKey)}</strong>
              <div className="settings-nav-description">{t(section.descriptionKey)}</div>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
